<template>
  <donut-widget
    :key="`${widgetKey}-${selectedOption.text}-${upd}${loading ? 'fetching':'fetched'}`"
    :data="data"
    :loading="loading"
  >
    <template v-slot:title>
      <div class="pl-1 mb-1">

        <b-dropdown
          variant="link"
          toggle-class="p-0"
          no-caret
        >
          <template #button-content>
            <div class="d-flex align-items-center">

              <h5 class="heading text-heavy mb-0">
                {{ selectedOption.text }}
              </h5>
              <GjIcon
                class="icon-right"
                name="ArrowDown"
                size="17"
              />
            </div>
          </template>
          <template v-for="item in widgetOptions">
            <b-dropdown-item
              :key="item.id"
              @click="() => {
                selectedOption=item;
                upd +=1
              }"
            >
              {{ item.text }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </div>
    </template>
  </donut-widget>
</template>

<script>
import DonutWidget from './DonutWidget.vue'

export default {
  name: 'EncodingStatusWidgets',
  components: {
    DonutWidget,
  },
  props: {
    loadingJobs: {
      type: Boolean,
      default: false,
    },
    loadingOutputs: {
      type: Boolean,
      default: false,
    },
    jobs: {
      type: Array,
      default: () => [],
    },
    outputs: {
      type: Array,
      default: () => [],
    },
    widgetKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      upd: 0,
      selectedOption: {
        id: 0,
        text: 'Jobs',
      },
      widgetOptions: [
        {
          id: 0,
          text: 'Jobs',
        },
        {
          id: 1,
          text: 'Outputs',
        },
      ],
    }
  },
  computed: {
    data() {
      return this.selectedOption.id === 0 ? this.jobs : this.outputs
    },
    loading() {
      return this.selectedOption.id === 0 ? this.loadingJobs : this.loadingOutputs
    },
  },

}
</script>

<style>

</style>
